import { render, staticRenderFns } from "./blok-date.vue?vue&type=template&id=a38b1d54&scoped=true&"
import script from "./blok-date.vue?vue&type=script&lang=js&"
export * from "./blok-date.vue?vue&type=script&lang=js&"
import style0 from "./blok-date.vue?vue&type=style&index=0&id=a38b1d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38b1d54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a38b1d54')) {
      api.createRecord('a38b1d54', component.options)
    } else {
      api.reload('a38b1d54', component.options)
    }
    module.hot.accept("./blok-date.vue?vue&type=template&id=a38b1d54&scoped=true&", function () {
      api.rerender('a38b1d54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-date.vue"
export default component.exports